// How often will we ask auth0 for a new access token.
//
// The Auth0 API's access-token TTL is 1200s (20 min). Previously we refreshed
// at 1150s (19m10s) — a 50-second margin. In practice any delayed or failed
// refresh (browser background-tab throttling, network blip, transient auth0
// hiccup) would land outside that margin and leave the user with a dead
// token until the *next* refresh ~19 minutes later. Every API call in that
// gap returned 401 and bounced the user to the login screen mid-session.
//
// 600_000ms (10 min) puts us at 50% of TTL, so two consecutive failed
// refreshes are required to leak a dead token to the backend. The real
// architectural fix is to fetch the token in RTK Query's prepareHeaders so
// every request always carries a fresh token; this constant is the
// belt-and-suspenders fallback once that lands.
export const DEFAULT_ACCESS_TOKEN_REFRESH_INTERVAL_MS = 600_000; // 10 min
// export const DEFAULT_ACCESS_TOKEN_REFRESH_INTERVAL_MS = 1000 * 30; // 30 seconds (for testing purposes)

// after how long of inactivity will we log the user out in ui
export const DEFAULT_INACTIVITY_TIMEOUT_MS = 1000 * 60 * 20; // 20 minutes
// export const DEFAULT_INACTIVITY_TIMEOUT_MS = 1000 * 60 * 1; // 1 minute (for testing purposes)
